export const base64URLEncode = (string: ArrayBuffer) => {
  const data = new Uint8Array(string);

  return btoa(String.fromCharCode.apply(null, Array.from(data)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};
